<div [ngClass]="typeClasses">
  <button *ngIf="closeable" type="button" class="close" (click)="onDismiss($event)">
    <span aria-hidden="true">&times;</span>
  </button>
  {{ message | decodeHtmlString }}
  <ul *ngIf="issues?.length > 0">
    <li *ngFor="let issue of issues">{{ issue }}</li>
  </ul>
  <slot></slot>
</div>
